/**************************************************
 * Nombre:       Tarjeta_Resultados
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {descargarArchivo} from "../../Utilidades/descargarArchivo";
import {useNavigate} from "react-router";
import def_you_tube from '../../Recursos/def_youtube.svg'
import def_video from '../../Recursos/def_video.svg'
import 'video-react/dist/video-react.css';
import {formatoFechaDaysRedus} from "../../Utilidades/formatoFechaDaysRedus";

const Tarjeta_Resultados = ({item}) => {
    const navigate = useNavigate();

    const colocarBoton = (it) => {

        switch (it.seccion) {
            case 'Documento':
                return (
                    <Button
                        onClick={() => descargarArchivo(item.pdf, item.nombre + '.pdf')}
                        fullWidth sx={{fontSize: 12, borderRadius: 1}}>Descargar</Button>
                )
                break
            case 'Calendario':
                return (
                    <Button
                        onClick={() => navigate('/' + it.seccion + '/' + it.id)}
                        fullWidth sx={{fontSize: 12, borderRadius: 1}}>Mas detalle</Button>
                )
                break
            case 'Capacitaciones':
                return (
                    <Button
                        onClick={() => navigate('/' + it.seccion + '/' + it.id)}
                        fullWidth sx={{fontSize: 12, borderRadius: 1}}>Ir a Capacitacion</Button>
                )
                break
            case 'Mixlrs':
                return (
                    <Button
                        onClick={() => navigate('/' + it.seccion + '/' + it.id)}
                        fullWidth sx={{fontSize: 12, borderRadius: 1}}>Ir a Mixlrs</Button>
                )
                break
            case 'Videos':
            case 'Empresariales':
                return (
                    <Button
                        onClick={() => navigate('/' + it.seccion + '/' + it.id)}
                        fullWidth sx={{fontSize: 12, borderRadius: 1}}>Ir a Video</Button>
                )
                break

        }


    }


    const obtenerRecurso = (seccion) => {

        switch (seccion) {
            case 'Empresariales':
                return (
                    <img src={def_video} width={'100%'} height={'auto'} style={{borderRadius: 8}}/>
                )
                break
            case 'Videos':
                return (
                    <img src={def_you_tube} width={'100%'} height={'auto'} style={{borderRadius: 8}}/>
                )
                break
            default:
                return (
                    <img src={item.img} width={'100%'} height={'auto'} style={{borderRadius: 8}}/>
                )
        }

    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >


            <Grid container size={{xs: 5, sm: 5, md: 3}} sx={{justifyContent: 'flex-start'}}>
                {obtenerRecurso(item.seccion)}
            </Grid>

            <Grid container size={{xs: 7, sm: 7, md: 9}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={0}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', height: 'auto'}}>
                        <Typography sx={{fontWeight: 600, lineHeight: 1.1}}>{item.nombre}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography sx={{
                            fontSize: 12,
                            textOverflow: "ellipsis",
                            display: '-webkit-box',
                            overflow: 'hidden',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 5,

                        }}>
                            {item.participante ? item.participante : item.descripcion}
                        </Typography>
                    </Grid>

                    {item.hora &&
                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{
                                fontSize: 12,

                            }}>
                                {formatoFechaDaysRedus(item.fecha)}
                            </Typography>
                        </Grid>
                    }


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                        {colocarBoton(item)}
                    </Grid>

                </Grid>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Resultados